import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 20px;
`;

export const InputDateValue = styled.div`
  min-width: 100px;
  width: fit-content;
  padding: 0 10px;
  height: 35px;
  background-color: #ccc;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.softGray};
  cursor: pointer;
`;
